export const MAX_UPLOAD_SIZE = 1024 ** 3 * 5;
export const MAX_MULTIPART_VIDEO_UPLOAD_SIZE = 1024 ** 3 * 9.5; // 9.5 GB (we're limited by lambda storage of 10 GB)
